<template>
    <v-app-bar color="white" light height="92px" >
        <div class="d-none d-lg-flex">
            <v-btn @click="emitChanges" icon>
                <v-icon>mdi-menu</v-icon>
            </v-btn>
        </div>
        <div class="d-flex d-lg-none">
            <v-btn @click="emitChangesSidebar" icon>
                <v-icon>mdi-menu</v-icon>
            </v-btn>
            <v-col></v-col>
        </div>
        <v-toolbar-title>
            <v-img src="../../../../../src/assets/cgc.png"></v-img>
        </v-toolbar-title>
        <v-spacer></v-spacer>


<!--      <v-snackbar-->
<!--          :timeout="-1"-->
<!--          :value="dialog"-->
<!--          elevation="5"-->
<!--          top-->
<!--          absolute-->
<!--          left-->
<!--          shaped-->
<!--      >-->
<!--        <v-simple-table>-->
<!--          <template v-slot:default>-->
<!--            <tbody>-->
<!--            <tr>-->
<!--              <td class="font-weight-bold">Name</td>-->
<!--              <td class="pl-2">:</td>-->
<!--              <td class="px-5">{{$store.state.home.user.fullName}}</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <td class="font-weight-bold">Branch</td>-->
<!--              <td class="pl-2">:</td>-->
<!--              <td class="px-5">{{$store.state.home.user.branch}}</td>-->
<!--            </tr>-->
<!--            </tbody>-->
<!--          </template>-->
<!--        </v-simple-table>-->
<!--      </v-snackbar>-->

      <v-btn color="primary darken-2" dark
             @click="emitModal"  class="hidden-md-and-up">
        <v-icon dark>mdi-account</v-icon>
      </v-btn>


<!--      <v-dialog-->
<!--          v-model="dialog"-->
<!--          class="hidden-md-and-up"-->
<!--      >-->
<!--        <template v-slot:activator="{ on, attrs }">-->
<!--          <v-btn color="primary darken-2" dark v-bind="attrs"-->
<!--                 v-on="on"  class="hidden-md-and-up">-->
<!--            <v-icon dark>mdi-account</v-icon>-->
<!--          </v-btn>-->
<!--        </template>-->




<!--        <v-card class="hidden-md-and-up pt-5">-->

<!--          <v-card-text>-->
<!--            <v-simple-table>-->
<!--              <template v-slot:default>-->
<!--                <tbody>-->
<!--                <tr>-->
<!--                  <td class="font-weight-bold">Name</td>-->
<!--                  <td class="pl-2">:</td>-->
<!--                  <td class="px-5">{{$store.state.home.user.fullName}}</td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <td class="font-weight-bold">Branch</td>-->
<!--                  <td class="pl-2">:</td>-->
<!--                  <td class="px-5">{{$store.state.home.user.branch}}</td>-->
<!--                </tr>-->
<!--                </tbody>-->
<!--              </template>-->
<!--            </v-simple-table>-->
<!--          </v-card-text>-->

<!--          <v-divider></v-divider>-->

<!--          <v-card-actions class="d-flex justify-center">-->

<!--            <v-btn-->
<!--                color="primary"-->
<!--                class="mr-5"-->
<!--                @click="dialog = false"-->
<!--            >-->
<!--              Close-->
<!--            </v-btn>-->
<!--            <v-btn-->
<!--                color="primary"-->
<!--                dark-->
<!--                @click="logout"-->
<!--            >-->
<!--              Logout-->
<!--            </v-btn>-->
<!--          </v-card-actions>-->
<!--        </v-card>-->
<!--      </v-dialog>-->

<!--      <v-list class="hidden-md-and-up">-->
<!--        <v-menu bottom origin="center center" transition="scale-transition">-->
<!--          <template v-slot:activator="{ on }">-->
<!--            <v-btn color="primary darken-2" dark v-on="on">-->
<!--              <v-icon dark>mdi-account</v-icon>-->
<!--            </v-btn>-->
<!--          </template>-->
<!--          <v-list>-->
<!--            <v-list-item>-->
<!--              <v-list-item-title>{{ this.$store.state.home.user.fullName }}</v-list-item-title>-->
<!--            </v-list-item>-->
<!--            <div class="my-2">-->
<!--              <v-btn @click="logout" text large color="#1c3d50">Log Out</v-btn>-->
<!--            </div>-->
<!--          </v-list>-->
<!--        </v-menu>-->
<!--      </v-list>-->



        <v-list dense class="hidden-sm-and-down text-left">
            <v-list-item-group>
                <v-list-item>
                    <v-list-item-content>
                        <tbody class="subtitle-1">
                        <tr>
                            <td class="font-weight-bold">Name</td>
                            <td class="pl-2">:</td>
                            <td class="px-5">{{$store.state.home.user.fullName}}</td>
                        </tr>
                        <tr>
                            <td class="font-weight-bold">Branch</td>
                            <td class="pl-2">:</td>
                            <td class="px-5">{{$store.state.home.user.branch}}</td>
                        </tr>
                        </tbody>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>



        <v-btn @click="logout" color="primary darken-2" class="mt-2 hidden-sm-and-down text-left">Logout</v-btn>
    </v-app-bar>
</template>

<script>
    import {EventBus} from '../../../../_helpers'
    import {homeService} from '../../../../services'

    export default {
        name: "DashboardCoreAppBar",
        data() {
            return {
              dialog: false
            }
        },
        methods: {
            emitChanges: function () {
                EventBus.$emit('Clicked')
            },
            emitChangesSidebar: function () {
                EventBus.$emit('Sidebar')
            },
            logout: function () {
                homeService.logout().then(
                    EventBus.$emit('logout')
                ).catch(function () {
                    console.log("could not log out")
                })
            },
          emitModal: function() {
            EventBus.$emit('openModal')
          }
        }
    }
</script>

<style scoped>

</style>
